var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const POLL_INTERVAL_MS = 8e3;
const MAX_BACKOFF_MS = 6e4;
const MAX_SETTLING_POLLS = 5;
const updateText = (element, value) => {
  if (!element || element.textContent === value) {
    return;
  }
  element.textContent = value;
  element.dataset.justUpdated = "true";
  setTimeout(() => Reflect.deleteProperty(element.dataset, "justUpdated"), 1e3);
};
const applyResults = (container, data) => {
  updateText(container.querySelector("[data-election-votes-count]"), data.votes_count_text);
  (data.questions || []).forEach((question) => {
    const questionNode = container.querySelector(`[data-results-question="${question.id}"]`);
    if (!questionNode) {
      return;
    }
    updateText(questionNode.querySelector("[data-question-votes-count]"), question.votes_count_text);
    (question.answers || []).forEach((answer) => {
      const answerNode = questionNode.querySelector(`[data-results-answer="${answer.id}"]`);
      if (!answerNode) {
        return;
      }
      updateText(answerNode.querySelector("[data-answer-votes-count]"), answer.votes_count_text);
      updateText(answerNode.querySelector("[data-answer-votes-percent]"), answer.percent_text);
      const bar = answerNode.querySelector("[data-answer-bar]");
      if (bar) {
        bar.style.width = `${answer.percent}%`;
        bar.parentElement.setAttribute("aria-valuenow", String(Math.round(answer.percent)));
      }
    });
  });
  updateText(container.querySelector("[data-results-updated]"), data.synced_at_text);
};
const boot = () => {
  const container = document.getElementById("js-vocdoni-election-results");
  if (!container || !container.dataset.statusUrl) {
    return;
  }
  const url = container.dataset.statusUrl;
  let delay = POLL_INTERVAL_MS;
  let settlingPolls = 0;
  const poll = () => __async(null, null, function* () {
    try {
      const response = yield fetch(url, {
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
      });
      if (!response.ok) {
        throw new Error(`unexpected status ${response.status}`);
      }
      const data = yield response.json();
      applyResults(container, data);
      delay = POLL_INTERVAL_MS;
      if (!data.ongoing) {
        settlingPolls += 1;
        if (!data.stale || settlingPolls >= MAX_SETTLING_POLLS) {
          return;
        }
      }
    } catch (e) {
      delay = Math.min(delay * 2, MAX_BACKOFF_MS);
    }
    setTimeout(poll, delay);
  });
  poll();
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
